

























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ProsemirrorHelper } from '@getaccept/editor-lib';
import type { IField, IMergeValues } from '@getaccept/editor-lib';
import ProsemirrorViewerFormInput from './ProsemirrorViewerFormInput.vue';

@Component({
  components: {
    ProsemirrorViewerFormInput,
  },
  data: () => ({
    ProsemirrorHelper,
  }),
})
export default class InputCheckbox extends Vue {
  @Prop() checked: boolean;
  @Prop() hasUpdateError: boolean;
  @Prop() isUpdating: boolean;
  @Prop() editable: boolean;
  @Prop() fields: IField[];
  @Prop() fieldFocused: boolean;
  @Prop() input: IField;
  @Prop() isPdfViewer: boolean;
  @Prop() mergeValues: IMergeValues;

  get isDisabled(): boolean {
    return !this.editable && !this.isPdfViewer;
  }

  @Watch('fieldFocused')
  watchFieldFocused(fieldFocused: boolean) {
    if (fieldFocused) {
      const input: HTMLInputElement = document.getElementById(this.input.id) as HTMLInputElement;
      input.focus({
        preventScroll: true,
      });
    }
  }
}
